import { query_person_by_org_list } from 'liyu-pc-base/api/sys/index';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      page_index: 1,
      page_size: 2000,
    },
    watch: [],
  };
  return {
    getData: query_person_by_org_list,
    searchConfig: search_config,
  };
};
